import { BusinessInventoryScheduleEntity } from 'generated/graphql';
import { core } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

export type ProcessingScheduleInfo = {
  originalSchedule: Pick<BusinessInventoryScheduleEntity, 'id' | 'name' | 'isSpecialDay' | 'state'>;
} & {
  workflowInfo: Pick<core.WorkflowInfo, 'workflowId' | 'runId' | 'status'>;
} & {
  startedAt: number;
  unassignedReservationCount: number;
  historyId?: number;
};

interface State {
  processingSchedules: ProcessingScheduleInfo[];
}

const initialState: State = {
  processingSchedules: [],
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;

  const filterSchedulesById = (id: number) =>
    state.processingSchedules.filter(
      ({ originalSchedule }: ProcessingScheduleInfo) => originalSchedule.id !== id
    );

  switch (type) {
    case AppConstants.BUSINESS_INVENTORY_SCHEDULES_PROCESSING_ADD: {
      if (!payload.startedAt) {
        payload.startedAt = Date.now();
      }

      return {
        ...state,
        processingSchedules: [...state.processingSchedules, ...[payload]],
      };
    }

    case AppConstants.BUSINESS_INVENTORY_SCHEDULES_PROCESSING_UPDATE: {
      const allOtherSchedules = filterSchedulesById(payload.originalSchedule.id);
      allOtherSchedules.push(payload);

      return {
        ...state,
        processingSchedules: allOtherSchedules,
      };
    }

    case AppConstants.BUSINESS_INVENTORY_SCHEDULES_PROCESSING_REMOVE: {
      return {
        ...state,
        processingSchedules: filterSchedulesById(payload),
      };
    }

    default:
      return state;
  }
}
